import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  Button,
} from "shards-react";
import updateReports from "../../hooks/updateReports";


export default function UpdateReportsCard({ docs, selectedUser }) {
  const [reports, setReports] = useState({ overview: '', facebook: '', klaviyo: '' })

  useEffect(() => {
    setReports(selectedUser && docs.filter(doc => { return doc.id === selectedUser.id })[0].links)
  }, [docs, selectedUser])

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);

  const inputGroupChangeHandler = (event) => {
    setReports((prevState) => ({
       ...prevState,
       [event.target.id]: event.target.value
    }));
}

  async function handleUpdateReports(e) {
    e.preventDefault()

    try {
      setError('');
      setLoading(true);
      // Updates Firebase records with new report data
      updateReports(selectedUser.id, reports)
      setReports('')
    } catch (Error) {
      setError(Error)
    }
    setLoading(false);
  }
  return (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Update Current Report Links</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form onSubmit={handleUpdateReports}>
                <Row form>
                  {/* Invoice ID*/}
                  <Col md="12" className="form-group">
                    <label>Overview</label>
                    <FormInput
                      disabled={!selectedUser}
                      required
                      placeholder="Overview Link"
                      id="overview"
                      onChange={inputGroupChangeHandler}
                      value={reports.overview}
                    />
                  </Col>
                  <Col md="12" className="form-group">
                    <label>Facebook</label>
                    <FormInput
                      disabled={!selectedUser}
                      required
                      placeholder="Facebook Link"
                      id="facebook"
                      onChange={inputGroupChangeHandler}
                      value={reports.facebook}
                    />
                  </Col>
                  <Col md="12" className="form-group">
                    <label>Klaviyo</label>
                    <FormInput
                      disabled={!selectedUser}
                      required
                      placeholder="Klaviyo Link"
                      id="klaviyo"
                      onChange={inputGroupChangeHandler}
                      value={reports.klaviyo}
                    />
                  </Col>
                  <Col md="12" className="form-group">
                    <Button type="submit" disabled={loading || !selectedUser || !reports} className="d-flex" theme="primary">Update reports</Button>
                  </Col>
                  {error && error}
                </Row>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  )
}
